import * as React from 'react';
import { useFormikContext } from 'formik';
import { Button } from '@cian/button-component';
import { IFormValues } from '../../DealRentModal';

export interface ISendCodeButton {
  sendValidationCode(): void;
}

export const SendCodeButton = ({ sendValidationCode }: ISendCodeButton) => {
  const { errors } = useFormikContext<IFormValues>();

  return (
    <div>
      <Button type="button" disabled={Boolean(errors.phone)} onClick={sendValidationCode}>
        Подтвердить телефон
      </Button>
    </div>
  );
};
